<template>
  <div class="d-block text-left text-xs">
    <h4 class="m-0 mb-1">
      <i class="fa fa-user"></i> Información básica
    </h4>
    <hr class="m-0 m-3" />
    <div class="row mb-2">
      <div class="col-sm-6">
        <p>{{vendedor.nombre}} {{vendedor.apellido}}</p>
      </div>
      <div class="col-sm-6">
        <p>
          <span class="text-muted">RUT:</span>
          {{vendedor.rut}}-{{vendedor.dv}}
        </p>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-sm-12">
        <p>
          <i class="fa fa-phone text-muted mr-2"></i>
          {{vendedor.celular}}
        </p>
      </div>
      <div class="col-sm-12">
        <p>
          <i class="fa fa-envelope text-muted mr-2"></i>
          {{vendedor.email}}
        </p>
      </div>
    </div>

    <div class="p-3 bg-secondary">
      <h4 class="m-0 mb-1">
        <i class="fa fa-map-marker"></i> Localidad
      </h4>
      <hr class="m-0 m-3" />
      <div class="row mb-2">
        <div class="col-sm-6">
          <p>
            <span class="text-muted">Ciudad:</span>
            {{vendedor.ciudad}}
          </p>
        </div>
        <div class="col-sm-6">
          <p>
            <span class="text-muted">Comuna:</span>
            {{vendedor.comuna}}
          </p>
        </div>
      </div>

      <p class="m-0">
        <span class="text-muted">Dirección:</span>
        {{vendedor.direccion}}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalForm",
  props: ["vendedor"]
};
</script>

<style>
</style>
